// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-bar-container {
  position: fixed;
  top: 74px;
  left: 0;
  display: flex;
  justify-content: center;
  width: 18%;
  height: calc(100vh - 74px);
  background-color: #040b1e;
  z-index: 5;
  overflow: hidden;
  box-sizing: border-box;
}
@media (max-width: 1024px) {
  .side-bar-container {
    width: 28% !important;
  }
}
.side-bar-container .listItem {
  padding-top: 5px;
}
.side-bar-container .MuiListItemButton-root {
  height: auto !important;
  min-height: 40px;
  padding-top: 6px;
  padding-bottom: 6px;
}
.side-bar-container .list-item-text {
  min-width: 0;
  flex: 1 1;
}
.side-bar-container .list-item-text .MuiTypography-root {
  font-size: 14px !important;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.side-bar-container .list-item-icon1 {
  flex-shrink: 0;
}
.side-bar-container .list-item-icon1 img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.side-bar-container .list-item-icon {
  min-width: 24px !important;
  margin-left: auto;
  justify-content: flex-end;
}
.side-bar-container .list-item-icon img {
  width: 16px;
  height: 16px;
  object-fit: contain;
}
@media (max-width: 600px) {
  .side-bar-container {
    width: 180px !important;
  }
  .side-bar-container .MuiListItemButton-root {
    padding-left: 8px !important;
    padding-right: 6px !important;
  }
  .side-bar-container .list-item-text .MuiTypography-root {
    font-size: 12px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/Sidebar/style.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,0BAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;AACF;AACE;EAbF;IAcI,qBAAA;EAEF;AACF;AAAE;EACE,gBAAA;AAEJ;AACE;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAEE;EACE,YAAA;EACA,SAAA;AAAJ;AAEI;EACE,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAN;AAIE;EACE,cAAA;AAFJ;AAKE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAHJ;AAME;EACE,0BAAA;EACA,iBAAA;EACA,yBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AALJ;AAQE;EA/DF;IAgEI,uBAAA;EALF;EAOE;IACE,4BAAA;IACA,6BAAA;EALJ;EAQE;IACE,0BAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EANJ;AACF","sourcesContent":[".side-bar-container {\r\n  position: fixed;\r\n  top: 74px;\r\n  left: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 18%;\r\n  height: calc(100vh - 74px);\r\n  background-color: #040b1e;\r\n  z-index: 5;\r\n  overflow: hidden;\r\n  box-sizing: border-box;\r\n\r\n  @media (max-width: 1024px) {\r\n    width: 28% !important;\r\n  }\r\n\r\n  .listItem {\r\n    padding-top: 5px;\r\n  }\r\n\r\n  .MuiListItemButton-root {\r\n    height: auto !important;\r\n    min-height: 40px;\r\n    padding-top: 6px;\r\n    padding-bottom: 6px;\r\n  }\r\n\r\n  .list-item-text {\r\n    min-width: 0;\r\n    flex: 1;\r\n\r\n    .MuiTypography-root {\r\n      font-size: 14px !important;\r\n      line-height: 1.2;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n  }\r\n\r\n  .list-item-icon1 {\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .list-item-icon1 img {\r\n    width: 22px;\r\n    height: 22px;\r\n    object-fit: contain;\r\n  }\r\n\r\n  .list-item-icon {\r\n    min-width: 24px !important;\r\n    margin-left: auto;\r\n    justify-content: flex-end;\r\n  }\r\n\r\n  .list-item-icon img {\r\n    width: 16px;\r\n    height: 16px;\r\n    object-fit: contain;\r\n  }\r\n\r\n  @media (max-width: 600px) {\r\n    width: 180px !important;\r\n\r\n    .MuiListItemButton-root {\r\n      padding-left: 8px !important;\r\n      padding-right: 6px !important;\r\n    }\r\n\r\n    .list-item-text .MuiTypography-root {\r\n      font-size: 12px !important;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
